<template>
  <div class="mt-24">
    <BaseDivider color="v1-grey-3" />
    <div class="qrw-heading-md mt-24 mb-24">
      {{ $t("modificators_settings.title") }}
    </div>
    <div class="gap-row-sm" v-if="show_modificators">
      <div class="modificators-group-wrapper" v-for="(price_group, index) in dish.price_groups" :key="index">
        <div class="modificators-group-header">
          <div class="iqos-tooltip-helper-box" @mouseenter="$set(hover_map, index, true)"
            @mouseleave="$set(hover_map, index, false)" v-if="isGroupFromPOS(price_group)">
            <BaseIcon icon="lock" size="sm2" />
            <IQOSTooltip :backdrop="false" earPosition="left" v-if="hover_map[index]">
              {{ $t("modificators_settings.cant_delete_group") }}
            </IQOSTooltip>
          </div>

          <BaseIcon icon="unlock" size="sm2" class="v1-grey-6-color" v-else />
          <BaseInput class="modificators-name-input w-100" :placeholder="$t('modificators_settings.name_hint')"
            v-model="price_group.name" @blur="emitUpdate" v-if="!isLocalizing" />
          <BaseInput type="text" class="modificators-name-input w-100" :placeholder="price_group.name"
            @blur="emitUpdate" v-model="dish.i18n[currentProductLocaleIndex].price_groups[index].name
              " v-else />

          <div class="gap-column-1xs">
            <BaseButton icon="chevron-up" @click="moveGroup(index, -1)" :disabled="index == 0" size="md"
              color="v1-grey-10" variant="secondary" />
            <BaseButton @click="moveGroup(index, 1)" :disabled="index == dish.price_groups.length - 1"
              icon="chevron-down" size="md" color="v1-grey-10" variant="secondary" />
          </div>

          <BaseButton icon="trash" @click="confirm_delete_index = index" size="md" color="red-4"
            :disabled="isGroupFromPOS(price_group) && (price_group.single_select || price_group.min_count > 0)"
            variant="secondary" />
          <!-- {{ $t("modificators_settings.remove_group") }} -->
          <!-- </BaseButton> -->
        </div>

        <div class="modificators-group-content">
          <div class="modificator-group-actions gap-column-xs">
            <BaseTabSwitcher :value="price_group.single_select" @input="(t) => {
              price_group.single_select = t;
              emitUpdate();
            }
              " minWidth :disabled="isGroupFromPOS(price_group)" :tabs="[
                {
                  text: $t('menu_settings.variants'),
                  value: true,
                },
                {
                  text: $t('menu_settings.additions'),
                  value: false,
                },
              ]" />
            <div class="vertical-divider" v-if="dish.price_groups.length > 1 && index > 0"></div>

            <div class="modificator-linking-options w-100" v-for="(show_id, index) in price_group.show_for"
              :key="show_id">
              <BaseInput class="w-100" leftIcon="link" leftIconColor="green-6" rightIconColor="red-4" rightIcon="x"
                @iconClicked="
                  price_group.show_for.splice(index, 1);
                emitUpdate();
                " iconPosition="both" disabled :value="getLinkedModificatorName(price_group, show_id)" fullWidth />
            </div>

            <BaseButton @click="
              target_link_group_id = price_group._id;
            show_link_modal = true;
            " icon="connect" size="md" class="w-100" color="v1-grey-10" variant="secondary" v-if="
              dish.price_groups.length > 1 &&
              index > 0
            ">
              {{ $t("modificators_settings.link_btn") }}
            </BaseButton>


          </div>
          <!-- <div class="modificators-group-subheader gap-column-sm">
            <div class="modificators-group-order gap-column-sm w-100"></div>
            <div
              class="vertical-divider"
              v-if="dish.price_groups.length > 1"
            ></div>
            <div class="modificators-group-options"></div>
          </div> -->
          <BaseDivider color="v1-grey-4" class="mt-16 mb-16" />
          <div class="modificator-group-limits">
            <div class="group-limits-toggle-container w-100">
              <BaseToggleSwitcher class="mr-24" v-model="max_count_flags[index]" />
              <div class="qrw-heading-xs">
                {{
                  price_group.single_select
                    ? $t("modificators_settings.max_count_variants_hint")
                    : $t("modificators_settings.max_count_additions_hint")
                }}
              </div>

            </div>
            <div class="group-limits-input-container ml-24 w-100" v-if="
              max_count_flags[index] ||
              (price_group.max_count > 1 && price_group.max_count < 999)
            ">
              <BaseInput type="number" :disabled="isGroupFromPOS(price_group)" @blur="emitUpdate"
                v-model.number="price_group.max_count" fullWidth />
            </div>
          </div>
          <BaseDivider color="v1-grey-4" class="mt-16 mb-16" />

          <div class="modificator-row mb-8" v-if="false">
            <div class="modificator-stock-filler mr-24"></div>
            <div class="modificator-base-params w-100">
              <div class="modificator-name-filler"></div>
              <div class="modificator-info-filler">
                <div class="qrw-label-sm mr-8 bold v1-grey-7-color">
                  {{ $t("menu_settings.weight") }}
                </div>
                <div class="qrw-label-sm bold v1-grey-7-color">
                  {{ $t("menu_settings.price") }}
                </div>
              </div>
            </div>
          </div>

          <template v-for="(item, item_index) in price_group.items">
            <div class="modificator-row gap-column-xs" :key="item_index">
              <div class="modificator-stock">
                <BaseToggleSwitcher :value="item.stock" @input="(v) => {
                  item.stock = v;
                  emitUpdate();
                }
                  " />
              </div>
              <div class="modificator-info">
                <div class="modificator-base-params">
                  <BaseInput class="modificator-united-input mr-8" @blur="emitUpdate"
                    v-model="dish.price_groups[index].items[item_index].name" v-if="!isLocalizing" :placeholder="`${$t('modificators_settings.name_ph')} №${item_index + 1
                      }`" :valid="!!item.name" fullWidth />
                  <BaseInput class="mr-8" @blur="emitUpdate" v-model="dish.i18n[currentProductLocaleIndex].price_groups[index]
                    .items[item_index]
                    " :placeholder="item.name" v-else fullWidth />
                  <BaseUnitInput class="mr-8 modificator-united-input" :unitPlaceholder="$t('units.' + dish.unit)"
                    :placeholder="$t('menu_settings.weight')" @blur="emitUpdate" type="number"
                    v-model.number="item.weight" />
                  <BaseUnitInput class="modificator-united-input" :unitPlaceholder="currency.symbol"
                    :placeholder="$t('menu_settings.price')" :disabled="isPriceDisabledForItem(item)" @blur="emitUpdate"
                    v-model.number="item.price" type="number" :valid="!isNaN(item.price) && item.price !== null" />
                </div>
                <div class="modificator-integrations">
                  <div class="mt-16" v-if="canSelectPosterProduct(price_group, item)">
                    <PosterMenuInput :value="dish.price_groups[index].items[item_index]
                      .poster_product_id
                      " @input="(v) =>
                        setPriceGroupPosterProductId(index, item_index, v)
                        " @setData="(v) => setPriceGroupPosterData(index, item_index, v)
                          " :hide_with_modificators="false" />
                  </div>
                  <div class="mt-16" v-if="canSelectIikoProduct(price_group, item)">
                    <IikoMenuInput :value="dish.price_groups[index].items[item_index]
                      .iiko_product_id
                      " @input="(v) => setPriceGroupIikoProductId(index, item_index, v)
                        " @setData="(v) => setPriceGroupIikoData(index, item_index, v)
                          " />
                  </div>
                  <div class="mt-16" v-if="canSelectResicoProduct(price_group, item)">
                    <ResicoMenuInput :value="dish.price_groups[index].items[item_index]
                      .resico_product_id
                      " @input="(v) => setPriceGroupItemResicoProductId(index, item_index, v)" />
                  </div>
                </div>
              </div>
              <div class="modificator-actions">
                <BaseButton color="v1-grey-10" class="mr-8" variant="secondary" size="md" :disabled="item_index == 0"
                  icon="chevron-up" @click="moveGroupItem(index, item_index, -1)" />
                <BaseButton color="v1-grey-10" variant="secondary" size="md"
                  :disabled="item_index == price_group.items.length - 1" icon="chevron-down"
                  @click="moveGroupItem(index, item_index, 1)" />
              </div>
              <div class="modificator-actions">
                <BaseButton icon="trash" color="red-4" size="md" variant="secondary"
                  :disabled="isGroupItemFromPOS(price_group, item)"
                  @click="showDeleteModificatorUI(index, item_index)" />
              </div>
            </div>

            <BaseDivider class="mt-16 mb-16" color="v1-grey-4" :key="'divider' + item_index" />
          </template>

          <div class="modificator-add-container">
            <BaseButton variant="secondary" color="v1-grey-10" size="md" icon="plus" @click="addModificatorItem(index)">
              {{ $t("modificators_settings.add_modificator") }}
            </BaseButton>
          </div>
        </div>
      </div>
    </div>
    <div class="modificator-add-container mt-16">
      <BaseButton variant="secondary" color="v1-grey-10" size="md" icon="plus" @click="addModificatorGroup">{{
        $t("modificators_settings.add_group") }}
      </BaseButton>
    </div>

    <ModificatorsLinkModal :group_id="target_link_group_id" @close="show_link_modal = false" v-if="show_link_modal" />
    <AddModificatorGroupModal @close="add_group_modal = false" v-if="add_group_modal" />

    <InfoModal v-if="price_group_required_modal" @close="price_group_required_modal = false">
      {{ $t("modificators_settings.cant_delete_group") }}
    </InfoModal>

    <DangerConfirmModal @confirm="deleteModificatorGroup(confirm_delete_index)" @cancel="confirm_delete_index = -1"
      v-if="confirm_delete_index !== -1">
      {{ $t("modificators_settings.confirm_remove") }}
    </DangerConfirmModal>

    <DangerConfirmModal @confirm="
      deleteModificator(
        confirm_item_delete.group_index,
        confirm_item_delete.item_index
      )
      " @cancel="confirm_item_delete.active = false" v-if="confirm_item_delete.active">
      {{ $t("modificators_settings.confirm_remove_item") }}
    </DangerConfirmModal>
  </div>
</template>

<style scoped>
.modificators-group-header {
  padding: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  column-gap: 16px;
  background: var(--v1-grey-2-color);
  width: 100%;
  box-sizing: border-box;
  border-radius: 12px 12px 0 0;
}

.modificators-group-subheader {
  display: flex;
}

.modificators-group-order {
  display: flex;
}

.modificators-group-options {
  display: flex;
  min-width: fit-content;
}

.modificator-row {
  display: flex;
  width: 100%;

  align-self: center;
  align-items: center;
  align-content: center;
}

.modificator-info {
  display: flex;

  flex-direction: column;

  width: 100%;
}

.modificator-base-params,
.modificator-actions {
  display: flex;
}

.modificator-add-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.modificator-group-limits {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 32px;
}

.group-limits-toggle-container {
  display: flex;
  align-content: center;
  align-items: center;

}

.group-limits-input-container {
  padding-left: 16px;
  border-left: 1px solid var(--v1-grey-6-color);
}

.vertical-divider {
  border-left: 1px solid var(--v1-grey-5-color);
  height: 32px;
  width: 1px;
}

.modificator-linking-options {
  display: flex;
}

.modificators-name-input {
  width: 400px;
}

.modificator-group-actions {
  align-items: center;
  align-content: center;
}

.modificator-stock {
  padding-left: 16px;
}

.modificator-stock-filler {
  min-width: 56px;
  height: 16px;
}

.modificator-name-filler {
  width: 100%;
  height: 16px;
}

.modificator-info-filler {
  width: 440px;
}

.modificators-group-wrapper {
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.16);
  border-radius: 12px;
}

.modificators-group-content {
  padding: 16px;
  box-sizing: border-box;
  width: 100%;
  background: var(--v1-grey-1-color);
  border-radius: 0 0 12px 12px;

}

.modificator-united-input>>>.input-wrapper {
  width: 160px;
}

.modificator-united-input>>>.unit-box {
  width: 60px;
}
</style>

<script>
import AddModificatorGroupModal from "@/components/menu/AddModificatorGroupModal.vue";
import ModificatorsLinkModal from "@/components/menu/ModificatorsLinkModal.vue";
import InfoModal from "@/components/modals/InfoModal.vue";
import RoundCheckbox from "@/components/RoundCheckbox.vue";

import PosterMenuInput from "@/components/integrations/PosterMenuInput.vue";
import IikoMenuInput from "@/components/integrations/IikoMenuInput.vue";
import ResicoMenuInput from '@/components/integrations/ResicoMenuInput.vue'

import ModificatorLinkButton from "@/components/menu/ModifcatorLinkButton.vue";

export default {
  components: {
    AddModificatorGroupModal,
    ModificatorsLinkModal,
    PosterMenuInput,
    IikoMenuInput,
    ModificatorLinkButton,
    RoundCheckbox,
    InfoModal,
    ResicoMenuInput
  },
  data () {
    return {
      select_from_poster: false,
      show_modificators: true,
      show_link_modal: false,
      add_group_modal: false,

      target_link_group_id: null,

      price_group_required_modal: false,

      confirm_delete_index: -1,

      confirm_item_delete: {
        active: false,
        item_index: 0,
        group_index: 0,
      },

      editing_map: {},
      hover_map: {},

      max_count_flags: {},
    };
  },
  watch: {
    show_modificators () {
      this.$emit("showModificators", this.show_modificators);
    },
    "dish.price_groups" () {
      this.dish.price_groups.forEach((g, i) => {
        this.$set(
          this.max_count_flags,
          i,
          g.max_count != 1 && g.max_count !== 999
        );
      });
    },
  },
  methods: {
    addModificatorGroup () {
      if (!this.show_modificators) {
        this.show_modificators = true;
        return;
      }
      this.$store.commit("menu/addPriceGroup", {
        name: null,
        single_select: true,
        max_count: 1,
        items: [
          {
            name: null,
            price: null,
            weight: null,
            stock: true,
          },
          {
            name: null,
            price: null,
            weight: null,
            stock: true,
          },
        ],
      });
    },
    addModificatorItem (index) {
      this.$store.commit("menu/addPriceGroupItem", {
        index,
      });

      this.emitUpdate();
    },
    emitUpdate () {
      this.$store.dispatch("menu/updateProduct");
    },
    isGroupFromPOS (group) {
      if (this.dish.poster_product_id) {
        const product = this.$store.getters['poster/findPosterProduct'](
          this.dish.poster_product_id
        );

        if (!product) return false;

        return product.price_groups.some(
          pg => pg.poster_group_id == group.poster_group_id
        );
      }

      if (this.dish.iiko_product_id) return !!group.iiko_group_id;

      return false;
    },
    isGroupItemFromPOS (group, item) {
      return this.isGroupFromPOS(group) && (item.poster_product_id || item.poster_modificator_id || item.poster_modification_id || item.iiko_product_id);
    },
    checkRequiredGroup (group) {
      let is_required = false;

      if (this.hasPosterIntegration && this.dish.poster_product_id) {
        is_required = this.$store.getters["poster/isGroupRequired"](
          this.dish.poster_product_id,
          group
        );
      }

      if (this.hasIikoIntegration && this.dish.iiko_product_id) {
        is_required = this.$store.getters["iiko/isGroupRequired"](
          this.dish.iiko_product_id,
          group
        );
      }

      return is_required;
    },
    deleteModificator (group_index, item_index) {
      const name = this.dish.price_groups[group_index].items[item_index].name;

      const group = this.dish.price_groups[group_index];

      this.confirm_item_delete.active = false;

      if (group.items && group.items.length == 1) {
        if (this.checkRequiredGroup(group)) {
          this.price_group_required_modal = true;
          return;
        }
      }

      this.$store.commit("menu/removePriceGroupItem", {
        group_index,
        item_index,
      });

      if (this.dish.price_groups[group_index].items.length == 0) {
        this.deleteModificatorGroup(group_index);
      }

      this.$store.dispatch("auditlog/write", {
        type: "delete_menu_product_modificator",
        payload: {
          dish_name: this.dish.name,
          dish_id: this.dish._id,
          modificator_name: name,
        },
      });

      this.emitUpdate();
    },
    deleteModificatorGroup (index) {
      const group = this.dish.price_groups[index];

      if (this.checkRequiredGroup(group)) {
        this.confirm_delete_index = -1;

        this.price_group_required_modal = true;
        return;
      }

      let name = this.dish.price_groups[index].name;

      this.$store.commit("menu/removePriceGroup", {
        index,
      });

      this.emitUpdate();

      this.confirm_delete_index = -1;

      this.$store.dispatch("auditlog/write", {
        type: "delete_menu_product_modificators",
        payload: {
          dish_id: this.dish._id,
          dish_name: this.dish.name,
          name,
        },
      });
    },
    isPriceDisabledForItem (item) {
      if (item.poster_product_id) return true;

      if (
        this.blockPriceEdit &&
        (item.poster_modificator_id || item.poster_modification_id)
      ) {
        return true;
      }

      if (item.iiko_product_id) return true;

      return false;
    },

    setPriceGroupPosterProductId (group_index, item_index, value) {
      this.$set(
        this.dish.price_groups[group_index].items[item_index],
        "poster_modification_id",
        null
      );

      this.$set(
        this.dish.price_groups[group_index].items[item_index],
        "poster_modificator_id",
        null
      );

      this.$set(
        this.dish.price_groups[group_index].items[item_index],
        "poster_product_id",
        value
      );

      if (this.dish.price_groups[group_index].single_select)
        this.$store.commit("menu/setProductData", {
          key: "base_price",
          value: 0,
        });

      this.emitUpdate();
    },
    setPriceGroupPosterData (group_index, item_index, data) {
      this.$set(
        this.dish.price_groups[group_index].items[item_index],
        "price",
        data.base_price
      );

      if (!this.dish.image && data.image) {
        this.$store.commit("menu/setProductData", {
          key: "image",
          value: data.image,
        });
      }
    },
    setPriceGroupIikoProductId (group_index, item_index, value) {
      this.$set(
        this.dish.price_groups[group_index].items[item_index],
        "iiko_product_id",
        value
      );

      this.emitUpdate();
    },
    setPriceGroupItemResicoProductId (group_index, item_index, value) {
      this.$set(
        this.dish.price_groups[group_index].items[item_index],
        "resico_product_id",
        value
      );

      this.emitUpdate();
    },
    setPriceGroupIikoData (group_index, item_index, data) {
      this.$set(
        this.dish.price_groups[group_index].items[item_index],
        "price",
        data.price
      );

      if (data.iiko_group_id) {
        this.$set(
          this.dish.price_groups[group_index].items[item_index],
          "iiko_group_id",
          data.iiko_group_id
        );
      }
    },
    canSelectPosterProduct (group, item) {
      if (!this.hasPosterIntegration) return false;

      if (!this.dish.poster_product_id) return true;

      if (group.single_select) {
        if (group.poster_group_id) return false;
      }

      if (item.poster_modificator_id || item.poster_modification_id)
        return false;

      return true;
    },
    canSelectIikoProduct (group, item) {
      if (!this.hasIikoIntegration) return false;

      if (item.iiko_group_id) return false;

      if (!this.dish.iiko_product_id) return true;

      return true;
    },
    canSelectResicoProduct (group, item) {
      if (!this.hasResicoIntegration) return false;

      return true;
    },
    moveGroup (group_index, delta) {
      if (group_index == 0 && delta == -1) return;
      if (group_index == this.dish.price_groups.length - 1 && delta == 1)
        return;

      this.$store.commit("menu/rearrangePriceGroup", {
        old_index: group_index,
        new_index: group_index + delta,
      });
      this.emitUpdate();
    },
    moveGroupItem (group_index, item_index, delta) {
      this.$store.commit("menu/rearrangePriceGroupItem", {
        group_index,
        item_index,
        delta,
      });
      this.emitUpdate();
    },
    onLinkModificator (group) {
      if (!group.show_for) {
        this.target_link_group_id = group._id;
        this.show_link_modal = true;
      } else {
        this.$store.commit("menu/setPriceGroupData", {
          id: group._id,
          key: "show_for",
          value: null,
        });
        this.emitUpdate();
      }
    },
    setPriceGroupItemStock (group_index, item_index, value) {
      this.$set(
        this.dish.price_groups[group_index].items[item_index],
        "stock",
        value
      );

      this.emitUpdate();
    },
    getLinkedModificatorName (price_group, show_id) {
      const all_items = this.dish.price_groups.reduce((acc, g) => {
        const g_items = g.items.map((it) => ({
          ...it,
          parent: g.name,
        }));

        return acc.concat(g_items);
      }, []);

      const target = all_items.find((it) => it._id == show_id);

      if (!target) return null;

      return `${target.name} (${target.parent})`;
    },
    showDeleteModificatorUI (group_index, item_index) {
      this.confirm_item_delete.active = true;
      this.confirm_item_delete.group_index = group_index;
      this.confirm_item_delete.item_index = item_index;
    },
  },
  mounted () {
    if (!this.shouldShowSinglePriceOnly) this.show_modificators = true;
  },
  computed: {
    dish () {
      return this.$store.state.menu.product;
    },
    isLocalizing () {
      return this.$store.getters["menu/isLocalizing"];
    },
    currentProductLocaleIndex () {
      return this.$store.getters["menu/currentProductLocaleIndex"];
    },
    currentProductLocale () {
      return this.$store.getters["menu/currentProductLocale"];
    },
    currency () {
      return this.$store.state.currency;
    },
    groupNamePlaceholder () {
      const variant_groups = this.dish.price_groups.filter(
        (g) => g.single_select
      );

      return variant_groups.length > 1
        ? this.$t("modificators_settings.placeholder_required")
        : this.$t("modificators_settings.placeholder_optional");
    },
    shouldShowSinglePriceOnly () {
      const variant_groups = this.dish.price_groups.filter(
        (g) => g.single_select
      );
      const modificators_groups = this.dish.price_groups.filter(
        (g) => !g.single_select
      );

      return (
        variant_groups.length == 1 &&
        variant_groups[0].items.length == 1 &&
        modificators_groups.length == 0
      );
    },
    hasPosterIntegration () {
      return this.$store.getters.hasPosterIntegration;
    },
    hasIikoIntegration () {
      return this.$store.getters.hasIikoIntegration;
    },
    hasResicoIntegration () {
      return this.$store.getters.hasResicoIntegration;
    },
    blockPriceEdit () {
      if (this.hasPosterIntegration && this.dish.poster_product_id) {
        return true;
      }

      if (this.hasIikoIntegration && this.dish.iiko_product_id) {
        return true;
      }

      return false;
    },
    isDishValid () {
      return this.$store.getters["menu/isDishValid"];
    },
    highlightErrors () {
      return this.$store.state.menu.highlight_errors;
    },
  },
};
</script>
